// Accounting firm surface (en).
//
// New firm strings belong here. The older `rf.*` keys still live in locale-en.js
// and move here whenever they are touched anyway.
window.PlummeI18n.register('en', {
  // ------------------------------------------------- Loading in the firm surface
  // "Loading your books" is the customer app's line. In the firm surface these
  // are not your books, and usually not books at all.
  'rf.loading.firm': 'Loading your firm …',
  'rf.loading.clients': 'Fetching your clients …',
  'rf.loading.reconciliation': 'Fetching the reconciliations …',
  'rf.loading.control': 'Fetching the control tasks …',
  'rf.loading.ledger': "Loading the client's books …",
  'rf.pageError.title': 'The page could not be loaded',
  'rf.pageError.text': 'Reload the firm surface. If it persists, the script for this page is unavailable.',
  // ------------------------------------------------- Assigning to engagements
  'rf.client.assignCount': 'Assign ({count})',
  'rf.client.assignAll': 'Everyone in the firm',
  'rf.client.assignNobody': 'The firm has no active colleagues to put on the engagement yet.',
  'rf.client.assignRoleHint': 'The role applies to everyone you tick. Anyone already on the engagement gets the new role.',
  'rf.client.assignedMany': '{count} colleagues were put on the engagement',
  // ------------------------------------------------------------- Navigating out
  // My page is the user's own account, and at the same time the way out of the
  // firm surface. "The firm's books" only shows when the firm keeps its own books
  // in Plumme.
  'rf.nav.myPage': 'My page',
  'rf.nav.firmBooks': "To the firm's books",
});
